var React = require('react');

function Hammer32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M33 8.996c0 .265-.105.52-.293.707l-4 3.997a.993.993 0 0 1-.707.293.993.993 0 0 1-.707-.293l-3.797-3.794-8.091 8.09.302.303a.998.998 0 0 1 .241 1.023l-1 2.998a1.004 1.004 0 0 1-.241.391l-9 8.995a.997.997 0 0 1-1.414 0l-4-3.998a.996.996 0 0 1 0-1.414l9-8.996c.11-.11.244-.192.391-.242l3-.999a1 1 0 0 1 1.023.242l.284.283 8.091-8.09-6.789-6.785A1 1 0 0 1 16-.001h8a1 1 0 0 1 .707.294l2.789 2.787.797-.797a.999.999 0 1 1 1.414 1.414l-.797.797 3.797 3.794c.188.188.293.443.293.708zM12.729 18.15l-2.189.73-8.125 8.121L5 29.585l8.126-8.122.73-2.187-1.127-1.126zM23.586 2h-5.17L28 11.579l2.585-2.583L23.586 2z","key":1})]);
}

Hammer32px.displayName = "Hammer32px";

Hammer32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 33 32"};

module.exports = Hammer32px;

Hammer32px.default = Hammer32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/hammer-32px.svg
// module id = 1101
// module chunks = 0